const PRODUCTION_APP_ORIGIN = 'https://web-whatsup.link';

function getDefaultAppOrigin(): string {
	if (typeof window === 'undefined') {
		return PRODUCTION_APP_ORIGIN;
	}

	const { hostname, origin } = window.location;
	const isLocalhost = hostname === 'localhost' || hostname === '127.0.0.1';

	if (isLocalhost) {
		return 'http://localhost:3001';
	}

	if (hostname.endsWith('.b-cdn.net')) {
		return PRODUCTION_APP_ORIGIN;
	}

	return origin || PRODUCTION_APP_ORIGIN;
}

const DEFAULT_APP_ORIGIN = getDefaultAppOrigin();

// API Configuration
export const API_BASE_URL = process.env.REACT_APP_API_URL || `${DEFAULT_APP_ORIGIN}/api`;
export const SOCKET_URL = process.env.REACT_APP_SOCKET_URL || DEFAULT_APP_ORIGIN;
